<template>
  <div class="bjlsc">
    <headerBanner :bannerUrl='domain+data.bgpic'></headerBanner>
    <div class="common_title clearfix">
      <div class="icon"><i class="icons i5"></i></div><p><span class="EY_Regular">{{data.name}}</span></p>
    </div>

    <div class="bjlsc_detail">
      <div class='clearfix'>
        <div class="img_wrap">
           <a :href="domain+data.fileurl" v-if='data.fileurl'>
           <img :src="domain+data.litpic" alt="" v-if='data.litpic'>
          <p>点击查看</p></a>
        </div>
        <div class="text_wrap">
          <p class="title EY_BoldItalic">{{data.seotitle}}</p> 
          <div class="text_wrap_detail" v-html='data.content'>
            
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headerBanner from '@/components/public/header'
export default {
  name: 'bjlsc',
  data () {
    return {
      data: '',
      domain:'https://eympe.vapps.me'
    }
  },
  components:{
    headerBanner:headerBanner
  },
  mounted:function(){
     this.$http.post('https://eympe.vapps.me/index.php?g=Index&m=Index&a=get_category',
       {
          cid:3
        },
       {emulateJSON : true})
   .then((response) => {
         this.data=response.body.cate
         console.log(response)
         
     })
  }
}
</script>

<style scoped>
  i.i5{
    width: 0.33rem;
    height: 0.42rem;
    background-image: url(../../static/images/i1.png);
    background-size: 0.33rem 0.42rem;
  }
  .bjlsc_detail{
    padding: 0 0.36rem;
    
  }
  .img_wrap{
    float: left;
    width: 1.22rem;
  }
  .img_wrap img{
    width: 100%;
    box-shadow: 0.04rem 0.04rem 0.05rem #000;
    display: block;
    margin-bottom: 0.1rem;
  }
  .img_wrap p{
    font-size: 0.2rem;
    color: #060606;
  }
  .text_wrap{
    width: 3.5rem;
    float: right
  }
  .bjlsc_detail>div{
    padding: 0.3rem 0.34rem  0.3rem 0.18rem;
    background-color: #d0d0d0;
  }
  .text_wrap .title{
    font-size: 0.2rem;
    color: #000;
    font-style: italic;
    margin-bottom: 0.06rem;
  }
  .text_wrap_detail{
    font-size: 0.2rem;
    color: #060606;
  }
</style>


// WEBPACK FOOTER //
// src/components/tmc.vue